import { render } from "./ShowPurpose.vue?vue&type=template&id=760aa170&scoped=true&ts=true"
import script from "./ShowPurpose.vue?vue&type=script&lang=ts"
export * from "./ShowPurpose.vue?vue&type=script&lang=ts"

import "./ShowPurpose.vue?vue&type=style&index=0&id=760aa170&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760aa170"]])

export default __exports__